<template>
  <div class="">
    <md-app class="viewport">
      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar />
      </md-app-toolbar>

      <md-app-content class="pageContent">
        <slot></slot>

        <div class="divFooter">
          <Footer/>
        </div>

      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import navbar from "../toolbar/navbar.vue";
import Footer from '../content/landing/footer.vue'

export default {
  components: {
    navbar,
    Footer,
  }
}
</script>
<style lang="scss" scoped>
.viewport {
  height: 100vh;
  width: 100vw;
}

.md-content{
  background-color: #e4f9f54a;
}

.md-app-content {
  padding: 16px 0 0 0;
}

.md-toolbar, .md-toolbar-row, .md-app-toolbar, .md-app-toolbar-row {
  width:100%;
  min-height:50px !important;
  display:flex;
  align-items:center;
  align-content:center;
  transition:.3s cubic-bezier(.4,0,.2,1);
  transition-property:opacity,background-color,box-shadow,transform,color,min-height;
  will-change:opacity,background-color,box-shadow,transform,color,min-height
}

.pageContent {
  overflow-y: auto;
  height: calc(100vh - 50px);
  // -ms-overflow-style: none;  /* Internet Explorer 10+ */
  // scrollbar-width: none;  /* Firefox */
}

// .pageContent::-webkit-scrollbar {
//   display: none;  /* Safari and Chrome */
// }

.divFooter {
  bottom: 0;
  display: flow-root;
  height: auto;
  background: #40514e;
}

</style>
